import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

export function NumberOfResults(props) {
    return (
        <>
            <span id={props.id} data-testid={props.id}>
                {props.t('numberOfResults.count', { number: props.numberOfResults })}
            </span>
            {props.showText && ` ${props.t('numberOfResults.hits')}`}
        </>
    );
}

NumberOfResults.propTypes = {
    id: PropTypes.string.isRequired,
    numberOfResults: PropTypes.number.isRequired,
    showText: PropTypes.bool,
    t: PropTypes.func.isRequired,
};

export default connect(state => ({ numberOfResults: state.numberOfResults }))(withTranslation('common')(NumberOfResults));
